import changelogData from "../../../../../pages/electronic-journal/docs/changelog-electronic-journal.json5";
import * as React from 'react';
export default {
  changelogData,
  React
};